import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useId, useState } from "react";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import Alert from '@mui/material/Alert';
import { useTheme } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import ExternalLogin from "../partials/ExternalLogin";
import { useForm, FormContainer, FormErrorProvider } from "react-hook-form-mui";
import { useSettings } from "../context/SettingsContext";
import { useI18N } from "../context/I18NContext";
import { useFlow } from "../context/FlowContext";
import { BoxContainer, CustomTextFieldElement } from "../layouts/Theme";
import useWidgetStore from "../store/useWidgetStore";
import SigninForm from "../partials/account/SigninForm";
import RegisterForm from "../partials/account/RegisterForm";
import { usePreValidateConsumer } from "../hooks/query/usePreValidateConsumer";
import { Link } from "react-router-dom";
export default function SignIn(props) {
    var _a, _b, _c, _d, _e, _f;
    const flow = useFlow();
    const theme = useTheme();
    const { hasAccounts, hasRegistration, hasLogin, hasGoogleLogin, } = useSettings();
    const { setConsumer, setIsAccount, setIsGuest } = useWidgetStore();
    const { t } = useI18N();
    const formContextRegister = useForm({});
    const preValidateConsumerQuery = usePreValidateConsumer(formContextRegister);
    const errorsId = useId();
    const [error, setError] = useState();
    const onSubmitRegister = (data, event) => {
        preValidateConsumerQuery.refetch();
    };
    useEffect(() => {
        if (preValidateConsumerQuery.data) {
            let status = preValidateConsumerQuery.data.status.status, errors = [];
            if (status === 'failed') {
                let errorMessage = preValidateConsumerQuery.data.status.message;
                if (errorMessage.includes('#oa_reminder')) {
                    let link = t(errorMessage).match(/<a (.+?)>(.+?)<\/a>/);
                    if (link) {
                        let parts = errorMessage.toString().split(link[0]);
                        errorMessage = (_jsxs(_Fragment, { children: [_jsx("span", { children: parts[0] }), _jsx(Link, { to: "/oa_widget_passwordReminder1", children: link[2] }), _jsx("span", { children: parts[1] })] }));
                    }
                }
                else {
                    errorMessage = (_jsx(_Fragment, { children: errorMessage }));
                }
                errors.push(errorMessage);
                setError(errors);
            }
            else {
                //@ts-ignore
                const consumer = {
                    email: formContextRegister.getValues('email')
                };
                setConsumer(consumer);
                setIsAccount(false); // for, we're still a guest with the intention to register
                setIsGuest(true);
                if (flow.onNext) {
                    flow.onNext();
                }
            }
        }
    }, [preValidateConsumerQuery.data]);
    const onErrorRegister = (errors) => {
    };
    return (_jsxs(BoxContainer, { children: [hasAccounts && hasRegistration && !((_b = (_a = flow.currentView) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.showRegister) && (_jsx(FormContainer, { formContext: formContextRegister, onSuccess: onSubmitRegister, onError: onErrorRegister, children: _jsxs(FormErrorProvider, { onError: (error) => {
                        if (error.type === 'validate') {
                            console.log(error);
                        }
                        return t(error.type, 'error');
                    }, children: [_jsx(Typography, { variant: "h6", sx: {
                                marginBottom: 0,
                                color: theme.palette.text.primary
                            }, children: t('Nieuwe klant?') }), error && (_jsx(Alert, { id: errorsId, sx: { my: 2 }, severity: "error", children: error === null || error === void 0 ? void 0 : error.map((_error, i) => (_jsx(Typography, { children: typeof _error === 'string' ? t(_error) : _error }, i))) })), _jsx(CustomTextFieldElement, { required: true, label: t('E-mail adres'), name: 'email', type: "email", InputProps: {
                                startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(EmailIcon, { sx: { color: theme.palette.text.secondary } }) }))
                            }, sx: { my: 2 }, fullWidth: true }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", children: t('Ga verder als nieuwe klant') })] }) })), hasAccounts && hasLogin && (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "h6", component: "div", children: t('Inloggen') }), _jsx(SigninForm, {})] })), hasAccounts && hasRegistration && !!((_d = (_c = flow.currentView) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.showRegister) && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", component: "div", sx: { marginLeft: 1, flexGrow: 1, my: 2, color: theme.palette.text.primary }, children: t('Of vul je persoonlijke gegevens in') }), _jsx(RegisterForm, { mode: "register", registerRequired: !!((_f = (_e = flow.currentView) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.registerRequired) })] })), hasGoogleLogin && (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "h6", component: "div", children: t('Of log in met je Google account') }), _jsx(ExternalLogin, {})] }))] }));
}
